import { FC, useEffect, useState } from "react";

interface DelayedComponentProps {
  delay?: number;
  children: (props: { isReady: boolean }) => React.ReactNode;
}

export const DelayedComponent: FC<DelayedComponentProps> = ({
  delay = 1000,
  children,
}) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsReady(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  return children({ isReady });
};
